import { Outlet } from "react-router-dom";
import { Header } from "../components/pageLevel/header";
import { Footer } from "../components/pageLevel";

export default function StaticPageLayout() {
  return (
    <>
      <Header
        controlIdentifier="Online header"
        logoImage="https://www.allianz.com/content/dam/onemarketing/system/allianz-logo.svg"
        buttonTitle="Contact Us"
        contactUsImg="https://www.allianzretireplus.com.au/content/dam/onemarketing/azau/allianz-life-dam/images/woman-with-laptop-headset.svg"
      />

      <Outlet />

      <Footer
        logoImage="https://www.allianz.com/content/dam/onemarketing/system/allianz-logo.svg"
        footerImageOne="https://www.allianzretireplus.com.au/content/dam/onemarketing/azau/allianz-life-dam/footer-image/life-customer.jpg"
        footerImageTwo="https://www.allianzretireplus.com.au/content/dam/onemarketing/azau/allianz-life-dam/footer-image/life-ins-code.jpg"
        termOfUseLink="https://www.allianz.com.au/terms-of-use.html"
        privacyLink="https://www.allianz.com.au/privacy-policy.html"
        securityLink="https://www.allianz.com.au/security.html"
        disclaimerLink="https://www.allianz.com.au/disclaimer.html"
      />
    </>
  );
}
